import React from 'react'

const MappingAnomaliesPage = () => {
  return (
    <div>MappingAnomaliesPage</div>
  )
}

export default MappingAnomaliesPage;
